<template>
  <div class="sel-options-container">
    <div
      class="option-btn"
      :key="optn.value || optn.key"
      v-for="optn in options"
    >
      <span class="optn-text" v-tooltip:top.ellipsis="optn.name || optn.label">
        {{ optn.name || optn.label }}
      </span>
      <div class="close-btn" @click="(e) => onRemove(e, optn)">
        <BaseIcon name="closeButtonLight" width="1.438rem" height="1.438rem" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emit: ['getDeleteOption'],
  props: {
    /**
     *
     *Array of options to be displayed
     *
     */
    options: {
      type: Array,
      required: true,
    },
    /**
     *
     * Enable this to stop caputuring phase of remove event
     *
     */
    stopPropagation: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onRemove(event, option) {
      if (this.stopPropagation) event.stopPropagation();

      this.$emit('getDeleteOption', option);
    },
  },
};
</script>

<style lang="scss" scoped>
.sel-options-container {
  display: flex;
}
.option-btn {
  border-radius: 1.188rem;
  background-color: $bg-secondary;
  padding: 0.563rem 0.531rem 0.563rem 0.75rem;
  margin-left: 0.75rem;
  display: flex;
}
.close-btn {
  margin-left: 0.75rem;
  cursor: pointer;
}
.optn-text {
  @include truncate(95%);
  color: $color-brand-accent;
  max-width: 15rem;
}
</style>
